import React from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '80%',
    height                : '80%',
  },
  button: {
    float: 'right'
  }
};
 
class ModalBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }

  componentWillUnmount() {
    
  }

  afterOpenModal() {
    
  }

  render() {
    let Component = this.props.component;
    return (
      <Modal
        isOpen={this.props.isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.props.onClose}
        style={customStyles}
        contentLabel={this.props.title}
      >
        <button onClick={this.props.onClose}>X</button>
        <Component {...this.props} />
      </Modal>
    );
  }
};
 
export default ModalBox;